import React, { useContext, useEffect } from 'react';

import { useNavigate } from 'react-router-dom';
import ViewContainer from '../../common/components/Container/Container';
import { FlowConfigContext } from '../../providers/FlowConfigContext';
import Loading from '../../common/components/Loading/Loading';
import { Routes } from '../../config/routes';
import { UserFlow } from '../../config/networkConfig';
import { GatekeeperNetworkServiceContext } from '../../providers/GatekeeperNetworkService/GatekeeperNetworkServiceContext';
import { Resolver } from '../../config';

function ExplainerScreen(): JSX.Element {
  const { initialized } = useContext(FlowConfigContext);
  const navigate = useNavigate();
  const { gknServiceData } = useContext(GatekeeperNetworkServiceContext);

  /** A mapping from network names to explainer routes */
  const explainerMappings: Record<string, Routes> & Record<'default', Routes> = {
    [UserFlow.AGE_CHECK_13]: Routes.EXPLAINER_AGE_CHECK_13,
    [UserFlow.CAPTCHA]: Routes.EXPLAINER_CAPTCHA,
    [UserFlow.CIVIC_DEMO]: Routes.EXPLAINER_TEST,
    default: Routes.ERROR,
  };

  const navigateToNextStep = async () => {
    // For passes that don't require a validation process, determine which explainer screen to show.
    // Those with a validation process will
    const clientFlow = gknServiceData!.clientFlowType;
    const userFlow = Resolver.transformFlowType(clientFlow);
    const explainer = explainerMappings[userFlow] || explainerMappings.default;
    navigate(explainer);
  };

  useEffect(() => {
    if (!initialized) {
      return;
    }

    navigateToNextStep();
  }, [initialized]);

  return (
    <ViewContainer>
      <div className="document-fixed-height flex h-screen justify-center items-center">
        <Loading dataTestId="IN_PROGRESS" />
      </div>
    </ViewContainer>
  );
}
export default ExplainerScreen;
